import { IconFileDescription, IconUsers, IconShieldCheck, IconLayoutList } from "@tabler/icons";

const icons = { IconFileDescription, IconUsers, IconShieldCheck, IconLayoutList };

const utilities = {
  id: "pages",
  title: "Pages",
  type: "group",
  children: [
    {
      id: "e-paper",
      title: "E Paper",
      icon: icons.IconFileDescription,
      type: "item",
      url: "/e-paper",
      permission: "epaper.view",
    },
    {
      id: "staff",
      title: "Staff",
      icon: icons.IconUsers,
      type: "item",
      url: "/staff",
      permission: "staff.view",
    },
    {
      id: "roles",
      title: "Roles",
      icon: icons.IconShieldCheck,
      type: "item",
      url: "/roles",
      permission: "roles.view",
    },
   
  ],
};

export default utilities;
